import { GetLocalizeT } from '../../../utils/locales';
import { format } from '../dateUtils';
import isValidMail from '../validators/isValidEmail';
import isValidPhoneNumber from '../validators/isValidPhoneNumber';
import { Locales } from '../../../../tbd/old-routing';

export const requiredString =
  (t: GetLocalizeT<string>) =>
  <F, K>(f: F, k: K, v: string | null | undefined) => {
    if (!v?.length) return { message: t('forms.errorMessages.required') };
    return undefined;
  };

export const requiredNumber =
  (t: GetLocalizeT<string>) =>
  <F extends Record<string, unknown>, K extends keyof F>(
    f: F,
    k: K,
    v: number | undefined | null
  ) => {
    if (!v) return { message: t('forms.errorMessages.required') };
    return undefined;
  };

export const validatePositiveNumber =
  (t: GetLocalizeT<string>) =>
  <F extends Record<string, unknown>, K extends keyof F>(
    f: F,
    k: K,
    v: number | undefined | null
  ) => {
    if (typeof v === 'number' && v <= 0)
      return { message: t('forms.errorMessages.required') };
    return undefined;
  };

export const requiredFile =
  (t: GetLocalizeT<string>) =>
  <F, K>(f: F, k: K, v: File | null | undefined) => {
    if (!v) return { message: t('forms.errorMessages.required') };
    return undefined;
  };

export const requiredDate =
  (t: GetLocalizeT<string>) =>
  <F, K>(f: F, k: K, v: Date | null | undefined) => {
    if (!v) return { message: t('forms.errorMessages.required') };
    return undefined;
  };

export const dateLessOrEqualThen =
  (t: GetLocalizeT<string>, locale: Locales, maxDate: Date) =>
  <F extends Record<string, unknown>, K extends keyof F>(
    f: F,
    k: K,
    v: Date | null | undefined
  ) => {
    if (!v) return;
    if (v > maxDate)
      return {
        message: t('forms.errorMessages.lessOrEqualDate', {
          maxDate: format(maxDate, 'dd/MM/yyyy', locale),
        }),
      };
    return undefined;
  };

export const dateGreaterOrEqualThen =
  (t: GetLocalizeT<string>, locale: Locales, minDate: Date) =>
  <F extends Record<string, unknown>, K extends keyof F>(
    f: F,
    k: K,
    v: Date | null | undefined
  ) => {
    if (!v) return;
    if (v < minDate)
      return {
        message: t('forms.errorMessages.greaterOrEqualDate', {
          minDate: format(minDate, 'dd/MM/yyyy', locale),
        }),
      };
    return undefined;
  };

export const requiredBoolean =
  (t: GetLocalizeT<string>) =>
  <F, K>(f: F, k: K, v: boolean | null | undefined) => {
    if (!v) return { message: t('forms.errorMessages.required') };
    return undefined;
  };

export const mustBeAnswerBoolean =
  (t: GetLocalizeT<string>) =>
  <F, K>(f: F, k: K, v: boolean | null | undefined) => {
    if (v !== true && v !== false)
      return { message: t('forms.errorMessages.required') };
    return undefined;
  };

export const validateEmail =
  (t: GetLocalizeT<string>) =>
  <F extends Record<string, unknown>, K extends keyof F>(
    f: F,
    k: K,
    v: string | null | undefined
  ) => {
    if (v?.length && !isValidMail(v))
      return { message: t('forms.errorMessages.emailInvalid') };
    return undefined;
  };

export const validatePhone =
  (t: GetLocalizeT<string>) =>
  <F extends Record<string, unknown>, K extends keyof F>(
    f: F,
    k: K,
    v: string | null | undefined
  ) =>
    !!v?.length && !isValidPhoneNumber(v)
      ? { message: t('forms.errorMessages.notValid') }
      : undefined;

export const validatePassword =
  (t: GetLocalizeT<string>) =>
  <F extends Record<string, unknown>, K extends keyof F>(
    f: F,
    k: K,
    v: string | null | undefined
  ) => {
    const length = v?.length || 0;
    if (length < 8 && length > 0)
      return { message: t('forms.errorMessages.passwordNotValid') };
    return undefined;
  };
